import InlineButton from "../ui/inline-button";
import PrimaryButton from "../ui/primary-button";
import SecondaryButton from "../ui/secondary-button";

export interface CareersApplicationFormSuccessProps {
  onSubmitAnotherApplication: () => void;
}

export default function CareersApplicationFormSuccess({
  onSubmitAnotherApplication,
}: CareersApplicationFormSuccessProps) {
  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-2">
        <h3 className="font-montserrat text-heading-4 text-secondary-500 md:text-heading-2">
          Thank You for Applying!
        </h3>
        <p className="font-montserrat text-subheading-3-500 text-neutral-600 md:text-subheading-2">
          We appreciate your interest in joining Care Indeed.
        </p>
      </div>
      <div className="flex flex-col gap-2">
        <p className="font-montserrat text-body-1-300 text-neutral-500">
          Our team will review your application and reach out to you regarding
          the next steps.
        </p>
        <p className="font-montserrat text-body-1-300 text-neutral-500">
          In the meantime, get to know us better by visiting our About Us page
          or check out our FAQs for answers to common questions about the hiring
          process.
        </p>
      </div>
      <div className="flex flex-row gap-4">
        <PrimaryButton
          color="teal"
          href={"/about-us"}
        >
          About Us
        </PrimaryButton>
        <SecondaryButton
          color="gray"
          href={"/careers#careers-faqs"}
          onClick={(e) => {
            e.preventDefault();
            const element = document.querySelector("#careers-faqs");
            if (element) {
              const offset = 80;
              const elementPosition =
                element.getBoundingClientRect().top + window.scrollY;
              window.scrollTo({
                top: elementPosition - offset,
                behavior: "smooth",
              });
            }
          }}
        >
          FAQs
        </SecondaryButton>
      </div>
      <InlineButton
        color="gray"
        onClick={onSubmitAnotherApplication}
      >
        Submit another application
      </InlineButton>
    </div>
  );
}
